import { DocumentTypeHandler } from "../common/commonDomain";
import { GeneralMeetingMinutes } from "../common/commonGeneralMeetingDomain";
import { applyForm, GeneralMeetingMinutesForm } from "./generalMeetingMinutesDomain";
import { DocumentType } from "../../common/documents";

export const generalMeetingMinutesHandler: DocumentTypeHandler<
  DocumentType.general_meeting,
  GeneralMeetingMinutes,
  GeneralMeetingMinutesForm
> = {
  type: DocumentType.general_meeting,
  initNewForm: (dispatch, context) => new GeneralMeetingMinutesForm(dispatch, context),
  initForm: (form) => form.init(),
  handleEvent: (form, event) => form.handleEvent(event),
  applyForm: (form) => applyForm(form),
};
